import { OptionSetGroup } from './option-set-group';
import { FormsConstants } from './forms-constants';
import { FunctionalElement, FUNCTIONAL_ELEMENT_TYPE } from './functional-element';

export type DropDownOptionsFunctionalElement = Readonly<{
    label: string;
    type: FUNCTIONAL_ELEMENT_TYPE.DROP_DOWN_OPTIONS;
    optionSet: OptionSetGroup[];
    function: string;
}> &
    FunctionalElement;

export const initialDropDownOptionsFunctionalElement: DropDownOptionsFunctionalElement = {
    id: -1,
    xmlId: '',
    label: '',
    type: FUNCTIONAL_ELEMENT_TYPE.DROP_DOWN_OPTIONS,
    function: '',
    contentLoadedFromXml: false,
    controllingCheckpoint: '',
    controllingOption: undefined,
    disabled: false,
    parentId: -1,
    choices: {},
    remarks: '',
    remarksLabel: '',
    remarksXmlId: '',
    elementType: FormsConstants.ELEMENT_TYPE.UNKNOWN,
    optionSet: [],
};

export function isDropDownOptionsElement(f: FunctionalElement): f is DropDownOptionsFunctionalElement {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.DROP_DOWN_OPTIONS;
}

export enum FunctionTypes {
    SINGLE_SELECT = 'single_select',
    MULTI_SELECT = 'multi_select',
}

export enum EvaluationTypes {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
}
